import React from "react";
import '../StylingForms/ButtonStyling.css';  // Make sure the path is correct

const ShopButton = () => {
  return (
    <button className="medieval-logout-btn">
      Shop
    </button>
  );
};

export default ShopButton;
